// extracted by mini-css-extract-plugin
export default {"BackButton":"BackButton_BackButton__5I+rP"};